export default __webpack_public_path__ + "static/media/216.c5ab6bd6.png";